(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('ProductCurrentAccountLock', ProductCurrentAccountLock);

	ProductCurrentAccountLock.$inject = [ '$resource' ];

	function ProductCurrentAccountLock($resource) {
		var resourceUrl = 'api/product-current-account-locks/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : false
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
		});
	}
})();
